import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProjectDetailStageGridPage } from './project-detail-stage-grid';
import { BodyModule, GridModule, SharedModule } from '@progress/kendo-angular-grid';
import { PtKendoModule } from '../../../../_foundation/kendo/modules/pt.kendo.module';

@NgModule({
  declarations: [
    ProjectDetailStageGridPage,
  ],
  imports: [
    IonicPageModule.forChild(ProjectDetailStageGridPage),
    GridModule,
    BodyModule,
    SharedModule,
    PtKendoModule
  ],
})
export class ProjectDetailStageGridPageModule {}



// WEBPACK FOOTER //
// ./src/pages/setup/project-details/project-detail-stage-grid/project-detail-stage-grid.module.ts